import { Checkbox } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';
import { MedicalDeviceOrderFormRegister, MedicalDeviceOrderTillLimitFormBeanPart } from '../medicalDeviceOrder.types';

type TillLimitFieldProps = {
   readonly register: MedicalDeviceOrderFormRegister<MedicalDeviceOrderTillLimitFormBeanPart>;
};

export const TillLimitField = (props: TillLimitFieldProps): JSX.Element => {
   return (
      <Checkbox
         testId={'tillLimit'}
         controller={props.register('tillLimit')}
         label={medicalDevicesTranslationKeys.fields.tillLimit}
      />
   );
};
